import { Pool } from '../../models/pool';
import { createStringIdAdapter } from './common/string-id-adapter';

export const poolAdapter = createStringIdAdapter<Pool>();
